import Box from '@mui/material/Box'
import { Typography, Link, Button } from '@mui/material'
import MzAlert from '@markaaz/ui/MzAlert'
import { useFormik } from 'formik'
import * as yup from 'yup'

import MzInput from '@markaaz/ui/MzInputControls'
import LoginLogo from 'assets/logos/loginLogo.svg'
import MarkaazLogo from 'assets/logos/markaaz.svg'
import LoginGradient from 'assets/bg/loginGradient.svg'

const sx = {
  root: {
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '24px',
    padding: '24px',
    boxSizing: 'border-box',
  },

  banner: {
    height: '100%',
    maxHeight: '976px',
    width: '672px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '16px',
    backgroundImage: `url(${LoginGradient})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },

  bannerContent: {
    width: '416px',
    bgcolor: 'red',
  },

  bannerHeading: {
    marginTop: '43.94px',
    whiteSpace: 'pre-line',
    textAlign: 'center',
    fontFamily: 'Inter',
    fontSize: '48px',
    lineHeight: '46px',
    fontWeight: '600',
    letterSpacing: '-1px',
    color: '#0F1113',
  },

  bannerSubHeading: {
    marginTop: '29.4px',
    whiteSpace: 'pre-line',
    textAlign: 'center',
    fontFamily: 'Inter',
    fontSize: '32px',
    lineHeight: '40px',
    fontWeight: '400',
    letterSpacing: '-1px',
    color: '#0F1113',
  },

  contentWrap: {
    height: '100%',
    maxHeight: '976px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '672px',
  },

  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '390px',
  },

  logo: {
    width: '184px',
    height: '26px',
    mb: '48px',
    '@media (max-width: 1366px)': {
      mb: '28px',
    },
  },

  subHeading1: {
    fontFamily: 'Inter',
    fontSize: '24px',
    lineHeight: '32px',
    fontWeight: '600',
    letterSpacing: '-0.5px',
    color: '#242D34',
  },

  subHeading2: {
    fontFamily: 'Inter',
    fontSize: '14px',
    lineHeight: '20px',
    fontWeight: '400',
    letterSpacing: '0px',
    color: '#242D34',
    mb: '48px',
    '@media (max-width: 1366px)': {
      mb: '28px',
    },
  },

  email: {
    marginBottom: '24px',
    '& .MuiInputLabel-asterisk': {
      display: 'none',
    },
    '& .MuiInputLabel-root': {
      fontFamily: 'Inter',
      fontSize: '12px',
      fontWeight: 400,
      lineHeight: '16px',
      letterSpacing: '0px',
      color: '#242D34',
    },
    '& .MuiOutlinedInput-root': {
      marginTop: '4px',
      '& .MuiOutlinedInput-input': {
        height: '24px',
        padding: '8px 18px',
        color: '#242D34',
        fontFamily: 'Inter',
        fontSize: '16px',
        fontWeight: 400,
        lineHeight: '24px',
        letterSpacing: '0px',
      },
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: '1px solid #242D34 !important',
    },
  },

  passwordWrap: {
    margin: '0px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    mb: '56px',
    '@media (max-width: 1366px)': {
      mb: '28px',
    },
  },

  password: {
    '& svg': {
      fontSize: '22px',
    },
    '& .MuiInputLabel-asterisk': {
      display: 'none',
    },
    '& .MuiInputLabel-root': {
      fontFamily: 'Inter',
      fontSize: '12px',
      fontWeight: 400,
      lineHeight: '16px',
      letterSpacing: '0px',
      color: '#242D34',
    },
    '& .MuiOutlinedInput-root': {
      marginTop: '4px',
      '& .MuiOutlinedInput-input': {
        height: '24px',
        padding: '8px 18px',
        color: '#242D34',
        fontFamily: 'Inter',
        fontSize: '16px',
        fontWeight: 400,
        lineHeight: '24px',
        letterSpacing: '0px',
      },
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: '1px solid #242D34 !important',
    },
  },

  forgotPassword: {
    textTransform: 'none',
    textDecoration: 'none',
    padding: 0,
    minWidth: 'auto',
    '&:hover': {
      backgroundColor: 'transparent',
      textDecoration: 'none',
    },
    '&.MuiButtonBase-root.MuiButton-root.MuiButton-text': {
      fontFamily: 'Inter',
      fontSize: '14px',
      lineHeight: '20px',
      fontWeight: 400,
      letterSpacing: '0px',
      textDecoration: 'none',
      color: '#004BBD',
    },
  },

  submitWrap: {
    mb: '115px',
    '@media (max-width: 1366px)': {
      mb: '40px',
    },
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },

  submitWrap2: {
    mb: '58px',
    '@media (max-width: 1366px)': {
      mb: '38px',
    },
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },

  submit: {
    width: '390px',
    height: '40px',
    borderRadius: '4px',
    padding: '8px 16px',
    background: '#004BBD',
    border: '1px solid  #0043AA',
    color: 'white',
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: '16px',
    textTransform: 'none',
    '&:hover': {
      background: '#003a94',
    },
    '&.Mui-disabled': {
      background: '#F2F3F4',
      border: '1px solid #F2F3F4',
      color: '#C1C5C9',
      WebkitTextFillColor: '#C1C5C9 !important',
    },
  },

  footer: {
    width: '488px',
    fontFamily: 'Inter',
    fontSize: '12px',
    lineHeight: '16px',
    fontWeight: 400,
    letterSpacing: '0px',
    textAlign: 'center',
    color: '#0F1113',
  },

  contactUs: {
    fontFamily: 'Inter',
    fontSize: '12px',
    lineHeight: '16px',
    fontWeight: 400,
    letterSpacing: '0px',
    color: '#004BBD',
  },

  cookie: {
    fontFamily: 'Inter',
    fontSize: '12px',
    lineHeight: '16px',
    fontWeight: 400,
    letterSpacing: '0px',
    textTransform: 'none',
    padding: 0,
    minWidth: 'auto',
    color: '#004BBD',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
}

const validationSchema = yup.object({
  email: yup.string().email('Enter a valid email id').required('Email is required'),
  password: yup.string().required('Password is required'),
})

export default function Login({ isSubmitting, onSubmit, onForgot, onSignup, showNotification, onAlertClose }) {
  const initialValues = {
    email: '',
    password: '',
  }

  const formik = useFormik({
    initialValues: initialValues,
    onSubmit: async () => {
      await onSubmit(formik.values)
    },
    validationSchema,
    enableReinitialize: true,
    validateOnMount: false,
  })

  return (
    <Box sx={sx.root}>
      <Box sx={sx.banner}>
        <img src={LoginLogo} alt="logo" />
        <Typography sx={sx.bannerHeading}>Markaaz{'\n'}Complete</Typography>
        <Typography sx={sx.bannerSubHeading}>Verify businesses, build trust,{'\n'} grow with confidence.</Typography>
      </Box>
      <Box sx={sx.contentWrap} component="form" onSubmit={formik.handleSubmit}>
        <Box sx={sx.content}>
          <Box component="img" sx={sx.logo} src={MarkaazLogo} alt="logo" />
          <Typography sx={sx.subHeading1}>Log in with your work email</Typography>
          <Typography sx={sx.subHeading2}>Your email will not be shared with any third parties.</Typography>
          <MzInput
            sx={sx.email}
            name="email"
            label="Work Email"
            type="email"
            placeholder="yourname@company.com"
            autoComplete="off"
            noBorder
            fullWidth
            required
            error={formik.touched.email && !!formik.errors.email}
            helperText={formik.touched.email && formik.errors.email}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
          <Box sx={sx.passwordWrap}>
            <MzInput
              sx={sx.password}
              name="password"
              label="Password"
              placeholder="My Password"
              autoComplete="off"
              type="password"
              noBorder
              fullWidth
              required
              error={formik.touched.password && !!formik.errors.password}
              helperText={formik.touched.password && formik.errors.password}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            <Button sx={sx.forgotPassword} onClick={onForgot}>
              Forgot Password?
            </Button>
          </Box>
          <Box sx={showNotification.message ? sx.submitWrap2 : sx.submitWrap}>
            <Button
              sx={sx.submit}
              disabled={!(formik.isValid && formik.dirty) || isSubmitting}
              loading={isSubmitting}
              onClick={formik.handleSubmit}
              type="submit"
            >
              Log In
            </Button>

            {showNotification.message && (
              <MzAlert
                sx={{ alignItems: 'center', marginTop: '20px' }}
                severity={showNotification.type === 'success' ? 'success' : 'error'}
                onClose={onAlertClose}
              >
                {showNotification.message}
              </MzAlert>
            )}
          </Box>
        </Box>
        <Typography sx={sx.footer}>
          By creating an account, I agree to Markaaz’s Terms and Conditions (including arbitration, liability limits,
          and class waiver) and confirm I’ve read the Privacy Policy. Need help?{' '}
          <Link
            href="https://share.hsforms.com/1n5-LEIiqTUyScicS-czMBAcdn4z"
            target="_blank"
            rel="noreferrer"
            underline="none"
            sx={sx.contactUs}
          >
            Contact Us
          </Link>{' '}
          |{' '}
          <Button
            onClick={() => {
              const _hsp = (window._hsp = window._hsp || [])
              _hsp.push(['showBanner'])
            }}
            variant="text"
            disableRipple
            sx={sx.cookie}
          >
            Cookie Settings
          </Button>
        </Typography>
      </Box>
    </Box>
  )
}
